import { setContext } from '@apollo/client/link/context';

/* Create Apollo Link to supply token in auth header with every gql request */
const authLink = (getAccessTokenSilently, loginWithRedirect) =>
  setContext(async (_, context) => {
    let token;
    const { headers, skipToken, client, ...rest } = context;

    if (!skipToken && client !== 'ledgible-cms') {
      try {
        token = await getAccessTokenSilently();
      } catch (e) {
        // Handle expected auth errors gracefully
        if (e.error === 'login_required' || e.error === 'consent_required') {
          loginWithRedirect();
          // Return context without token - the request will fail and be handled by errorLink
          return { headers, ...rest };
        }
        // Re-throw unexpected errors
        throw e;
      }
    }

    if (token) {
      return {
        ...rest,
        headers: {
          ...headers,
          authorization: `Bearer ${token}`,
        },
      };
    }

    return { headers, ...rest };
  });

export default authLink;
